import Konva from "konva";

export class Shuttle extends Konva.Rect {
  tween: Konva.Tween | null = null;
}
